<app-metadata [graphName]="'social-investments'"></app-metadata>
<button mat-raised-button color="primary" (click)="addSocialInvestment()" i18n="add social investment@@add_social_investment">Add Social Investment</button>
<button mat-raised-button (click)="copyFromYear()" [disabled]="isLoadingCopy" style="margin-left: 8px;">
  {{ isLoadingCopy ? 'Loading…' : 'Copy from other year' }}
</button>
@if (data && helptexts && informations) {
  <mat-accordion style="display: block; margin-top: 16px;">
    @for (datum of data; track datum) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ datum.name || '(unnamed)' }}
          </mat-panel-title>
          <mat-panel-description>
            {{ datum.activityType || '' }}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <app-form
          [informations]="informations"
          [data]="datum"
          [helptexts]="helptexts[0]"
          [showDelete]="true"
          (deleted)="deleteSocialInvestment($event)"
          (dataSubmitted)="onData($event)"
        ></app-form>
      </mat-expansion-panel>
    }
  </mat-accordion>
}
